export const entity = {
    name: 'Handicap',
    facets: [{name: 'codeName', nameOptional: false, uniqueName: true}],
}

export const module_ = {
    object: 'Handicap',
    tKey: 'mTitle_handicap',
    defaultSortBy: 'name',
    defaultSortDirection: 'ASC',
    category: {
        path: 'mTitle_animals',
        icon: 'animal'
    },
    viewMap: {
        dt: [
            'code', 'name'
        ],
        form: [
            'code', 'name'
        ]
    }
}
